module.exports = __webpack_public_path__ + "6e09b6c0d31c8d9c7055076bf058e390.gif";